// extracted by mini-css-extract-plugin
export default {"containerBackground":"Testimonials_containerBackground__b2HmI","container":"Testimonials_container__FI6CL"};